import { NavLink } from "react-router-dom";
import BottomLine from "../BottomLine";
import { ArrowRightIcon } from "../Icons/Icons";

export default function InternalLink({
  path,
  text,
  icon,
  bottomLine,
}: InternalLinkProps): JSX.Element {
  return (
    <li className="bg-ldir-blue-100 border-t border-ldir-blue-pale">
      <NavLink
        to={path}
        className="flex grow justify-between py-5 pl-4 pr-3.5 text-lg text-ldir-brown-900 items-center"
      >
        <div className="flex items-center">
          <div className="mr-2">{icon}</div>
          {text}
        </div>
        <ArrowRightIcon />
      </NavLink>
      {bottomLine && <BottomLine />}
    </li>
  );
}

type InternalLinkProps = {
  path: string;
  text: string;
  icon?: JSX.Element;
  bottomLine?: boolean;
};
